import React, { useState } from "react";
import restaurants from "../assets/images/restaurants/1.png";
import location from "../assets/images/location.png";
import fillstar from "../assets/images/icons/star.png";
import group from "../assets/images/restaurants/user-group.png";
import search from "../assets/images/restaurants/search.png";
import arrow from "../assets/images/order/orange-arrow.png";
import star from "../assets/images/navbar/star.png";
import food from "../assets/images/order/food.png";
import RestaurantsItemCard from "../components/RestaurantsItemCard";
import AddOnes from "../modal/AddOnes";
import SigninModal from "../modal/SigninModal";
import Otp from "../modal/Otp";
import Welcome from "../modal/Welcome";
import GroupModal from "../modal/GroupModal";

const RestaurantsSearch = () => {
  const status = "open now"; // Example status, you can replace it with dynamic data
  const [activeTab, setActiveTab] = useState<string>("Popular");
  const [hasItemsInCart, setHasItemsInCart] = useState<boolean>(false);
  const [itemCounts, setItemCounts] = useState<{ [key: number]: number }>({});
  const [isAddOnesModalOpen, setIsAddOnesModalOpen] = useState<boolean>(false);
  const [isSignInModalOpen, setIsSignInModalOpen] = useState<boolean>(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState<boolean>(false);
  const [isGroupOpen, setIsGroupOpen] = useState<boolean>(false);

  const handleOrderNow = () => {
    setIsAddOnesModalOpen(false);
    setIsSignInModalOpen(true);
  };

  const handleGetStarted = () => {
    setIsSignInModalOpen(false);
    setIsOtpModalOpen(true);
  };

  const handleOtpVerify = () => {
    setIsOtpModalOpen(false);
    setIsWelcomeModalOpen(true);
  };

  const handleItemCountChange = (index: number, count: number) => {
    setItemCounts((prev) => ({
      ...prev,
      [index]: count,
    }));

    // Check if any item has count > 0
    const hasItems = Object.values({ ...itemCounts, [index]: count }).some(
      (c) => c > 0,
    );
    setHasItemsInCart(hasItems);
  };

  const offers = [
    {
      id: 1,
      discount: "20% OFF",
      title: "Flat 20% Off on Total Bill",
      description: "Pay Bill via Duddu's to get flat 20% off on total bill",
      terms:
        "Only on Orders upto 2,000, for selected restaurants only, not valid for many seats, single booking only",
      bgColor: "bg-orange-500",
    },
    {
      id: 2,
      discount: "15% OFF",
      title: "Flat 15% Off on Weekend Orders",
      description: "Get 15% discount on all weekend bookings",
      terms:
        "Valid on Saturday and Sunday only, minimum order value ₹500, cannot be combined with other offers",
      bgColor: "bg-orange-500",
    },
  ];

  const items = [
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      details: "25 - 30 mins",
    },
  ];

  return (
    <div className="flex border-2 bg-[#FFFFFF]">
      <div className="w-[35%] border-r py-6">
        <div className="px-8">
          <h6 className="text-[#6A6A6A] text-left font-Urbanist text-[16px] font-medium leading-[20px] ml-[23px]">
            Search / Asian Kitchen
          </h6>

          {/* Restaurants Details */}
          <div className="mt-4">
            <div className="relative h-[375px] min-w-[400px] w-full">
              <img
                src={restaurants}
                alt="Asian Kitchen"
                className=" object-cover rounded-[16px] h-full w-full"
              />
              <div
                className={`absolute top-8 right-0 inline-flex justify-center items-center py-[5px] px-[11px] gap-[11px] rounded-l-[4.267px] ${status === "open now" ? "bg-[#FF8A00]" : "bg-[#C96B03]"}`}
              >
                <p
                  className={`${status === "open now" ? "text-white" : "text-black"} font-Urbanist text-[12.8px] font-semibold leading-[140%]`}
                >
                  {status}
                </p>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div className="w-[70%]">
                <div className="mt-[16px]">
                  <h6 className="text-[#050505] text-left font-Urbanist text-[22px] font-semibold leading-[140%]">
                    Asian Kitchen
                  </h6>
                </div>
                <div className="flex justify-between items-center mt-[4px]">
                  <div className="flex gap-2">
                    <img
                      src={location}
                      alt="location"
                      className="h-[20px] w-[20px]"
                    />
                    <span className="text-[#6A6A6A] text-left font-Urbanist text-[16px] font-medium leading-[20px]">
                      Sector 62, Noida
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <img
                      src={fillstar}
                      alt="star"
                      className="h-[20px] w-[20px]"
                    />
                    <span className="text-[#6A6A6A] text-left font-Urbanist text-[16px] font-medium leading-[20px]">
                      4.5 (128)
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-[20px]">
                <div>
                  <img
                    src={group}
                    alt="group"
                    className="h-[24px] w-[24px] cursor-pointer"
                    onClick={() => setIsGroupOpen(true)}
                  />
                </div>
                <div>
                  <img src={star} alt="star" className="h-[24px] w-[24px] cursor-pointer" />
                </div>
              </div>
            </div>
          </div>

          {/* -------options-- */}
          <div className="flex justify-between my-[24px]">
            <h6 className="px-[12px] py-[8px] w-[125px] flex justify-center items-center rounded-[10px] border-2">
              Free Delivery
            </h6>
            <h6 className="px-[12px] py-[8px] w-[125px] flex justify-center items-center rounded-[10px] border-2">
              Fast Service
            </h6>
            <h6 className="px-[12px] py-[8px] w-[125px] flex justify-center items-center rounded-[10px] border-2">
              Spicy Lovers
            </h6>
          </div>

          <p className="text-[#8F8E8C] text-left font-Urbanist text-[18px] font-medium leading-[22px]">
            Discover the best handcrafted foods in Noida, we use 100% fresh
            ingredients to bring you the ultimate foood experience.
          </p>

          {/* ----------available offers ----------*/}
          <div className="mt-[20px]">
            <h6 className="text-[#050505] text-left font-Urbanist text-[18px] font-semibold leading-[140%]">
              Offers Available
            </h6>
            {offers.map((offer) => (
              <div
                key={offer.id}
                className="flex items-center max-w-2xl w-full mt-[12px]"
              >
                {/* Left Orange Strip */}
                <div
                  className={`${offer.bgColor} text-white w-[35px] h-[122px] rounded-l-2xl flex items-center justify-center`}
                >
                  <p className="rotate-[-90deg] text-[14px] font-extrabold leading-[20px] whitespace-nowrap ">
                    {offer.discount}
                  </p>
                </div>
                <div className="flex-1 bg-gray-100 border border-gray-300 rounded-r-2xl p-2 flex justify-between items-center">
                  {/* Text Content */}
                  <div>
                    <div className="px-[4px] py-[10px] border-b-2 border-dashed">
                      <h3 className="text-[#050505] text-left font-Urbanist text-[16px] font-medium leading-[20px]">
                        {offer.title}
                      </h3>
                      <p className="text-[#6A6A6A] text-left font-Urbanist text-[12px] font-normal leading-[17px]">
                        {offer.description}
                      </p>
                    </div>
                    <p className="text-[#6A6A6A] text-left font-Urbanist text-[11px] font-normal leading-[146%] mt-3 max-w-md">
                      {offer.terms}
                    </p>
                  </div>

                  <button className="text-purple-700 font-Urbanist text-[16px] font-semibold leading-[17px] -mt-[47px]">
                    APPLY
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-[65%] border-l relative">
        {/* Tabs */}
        <div className="flex border-b border-gray-200 mt-[15px]">
          <div className="flex justify-center items-center mx-[20px]">
            <img src={search} alt="search" className="h-[24px] w-[24px] " />
          </div>
          {[
            { label: "Popular", count: 12 },
            { label: "Pizza", count: 8 },
            { label: "Burger", count: 20 },
            { label: "Momos", count: 16 },
            { label: "Biryani", count: 5 },
            { label: "Non-veg", count: 15 },
            { label: "Vegan", count: 10 },
          ].map((tab) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(tab.label)}
              className={`relative px-5 py-2 text-sm font-medium transition-colors duration-200
              ${
                activeTab === tab.label
                  ? "text-[#FF8A00]"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label} ({String(tab.count).padStart(2, "0")})
              {activeTab === tab.label && (
                <span className="absolute left-0 bottom-0 h-[2px] w-full bg-[#FF8A00] rounded-full"></span>
              )}
            </button>
          ))}
        </div>

        {/* items section */}
        <div className="px-12">
          {items.map((item, index) => (
            <RestaurantsItemCard
              key={index}
              image={item.image}
              itemName={item.itemName}
              itemPrice={item.itemPrice}
              discountedPrice={item.discountedPrice}
              details={item.details}
              onCountChange={(count) => handleItemCountChange(index, count)}
            />
          ))}
        </div>

        {hasItemsInCart && (
          <div className="fixed bottom-[20px] left-2/3 transform -translate-x-1/2 z-50">
            <div
              className="w-[364px] flex justify-between py-[12px] pl-[24px] pr-[12px] items-center gap-2 bg-[#FF8A00] text-white rounded-[150px] cursor-pointer shadow-[0 2px 12px 10px rgba(151, 57, 193, 0.15)]"
              onClick={() => setIsAddOnesModalOpen(true)}
            >
              <p className="text-white text-center font-Urbanist text-[20px] font-semibold leading-[140%]">
                Order Now
              </p>
              <div className="h-[42px] w-[42px] flex justify-center items-center bg-white rounded-full">
                <img
                  src={arrow}
                  alt="right arrow"
                  className="h-[41px] w-[30px] stroke-[2.587px] stroke-[#FB8606]"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* AddOnes Modal */}
      <AddOnes
        isOpen={isAddOnesModalOpen}
        onClose={() => setIsAddOnesModalOpen(false)}
        count={Object.values(itemCounts).reduce((sum, count) => sum + count, 0)}
        onOrderNow={handleOrderNow}
      />

      {/* SignIn Modal */}
      <SigninModal
        isOpen={isSignInModalOpen}
        onClose={() => setIsSignInModalOpen(false)}
        onGetStarted={handleGetStarted}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
      />

      {/* OTP Modal */}
      <Otp
        isOpen={isOtpModalOpen}
        onClose={() => setIsOtpModalOpen(false)}
        mobileNumber={mobileNumber}
        onVerify={handleOtpVerify}
      />

      {/* Welcome Modal */}
      <Welcome
        isOpen={isWelcomeModalOpen}
        onClose={() => setIsWelcomeModalOpen(false)}
        count={Object.values(itemCounts).reduce((sum, count) => sum + count, 0)}
      />

      {/* Group Modal */}
      {isGroupOpen && <GroupModal onClose={() => setIsGroupOpen(false)} />}
    </div>
  );
};

export default RestaurantsSearch;
